export default function TooltipArrowIcon({ className }: { className?: string }) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="13" height="8" viewBox="0 0 13 8" fill="none">
      <path d="M6.5 8L0.870835 0.5L12.1292 0.500001L6.5 8Z" fill="currentColor" />
    </svg>
  );
}
